import { render, staticRenderFns } from "./ClientsListContainer.vue?vue&type=template&id=879e41fa&"
import script from "./ClientsListContainer.vue?vue&type=script&lang=js&"
export * from "./ClientsListContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports